import { getFromFIGVault } from '../api/figApi';
import { getAgencySettings } from './invoiceSettings';
// hexToRgb was defined here until proposalLayout.js needed it too; it now
// lives in pdfText.js. Pure move — same function, same null-on-invalid
// behavior the `|| FALLBACK_COLORS.x` chains below depend on.
import { hexToRgb } from './pdfText';

const FALLBACK_COLORS = {
  primary: hexToRgb('#660099'),
  secondary: hexToRgb('#008b11'),
  tertiary: hexToRgb('#4A0033'),
  accent: hexToRgb('#B8860B'),
  text: hexToRgb('#1A1A1A'),
};

/**
 * Fetch brand assets (logo PNGs + colors) from FIG_Settings + FIGVault.
 *
 * @param {Function} getToken
 * @returns {{ logoBytes: Uint8Array|null, leafBytes: Uint8Array|null, colors: Object }}
 */
export async function getBrandAssets(getToken) {
  const settings = await getAgencySettings(getToken);
  const token = await getToken();

  const colors = {
    primary: hexToRgb(settings.BrandPrimaryHex) || FALLBACK_COLORS.primary,
    secondary: hexToRgb(settings.BrandSecondaryHex) || FALLBACK_COLORS.secondary,
    tertiary: hexToRgb(settings.BrandTertiaryHex) || FALLBACK_COLORS.tertiary,
    accent: hexToRgb(settings.BrandAccentHex) || FALLBACK_COLORS.accent,
    text: hexToRgb(settings.BrandTextHex) || FALLBACK_COLORS.text,
  };

  let logoBytes = null;
  let leafBytes = null;

  // Fetch logo PNG
  if (settings.BrandLogoHorizontalPath) {
    try {
      const blob = await getFromFIGVault(token, settings.BrandLogoHorizontalPath);
      logoBytes = new Uint8Array(await blob.arrayBuffer());
    } catch (err) {
      console.warn('[BrandAssets] Logo not found, using text fallback:', err.message);
    }
  }

  // Fetch leaf PNG
  if (settings.BrandLeafPath) {
    try {
      const blob = await getFromFIGVault(token, settings.BrandLeafPath);
      leafBytes = new Uint8Array(await blob.arrayBuffer());
    } catch (err) {
      console.warn('[BrandAssets] Leaf not found, skipping:', err.message);
    }
  }

  return { logoBytes, leafBytes, colors };
}
